






import { Component, Vue } from "vue-property-decorator";
import { getExtensionInfo } from "@/services/customExtensions/customExtensionService";
import { CustomExtension } from "@/services/customExtensions/types";
import moment from "moment";

@Component
export default class CustomExtensionPreviewModal extends Vue {
    customExtension = {} as CustomExtension;

    open(customExtension: CustomExtension) {
        this.customExtension = customExtension;
        this.$bvModal.show("modal-customExtensionPreview");
    }

    hide() {
        this.$bvModal.hide("modal-customExtensionPreview");
    }
}
